<canvas baseChart
        [data]="data"
        [options]="options"
        [type]="'bar'"
        [style.width]="'100%'"
        [style.height]="'100%'">
</canvas>
